import React from 'react';

import { useSelector } from 'react-redux';

import { FabricRenderer } from 'src/components/fabric-html-renderer';
import { useIntl } from 'src/hooks/intl';
import {
  getPullRequestDescription,
  getIsCurrentPullRequestOpen,
  getContainerId,
} from 'src/redux/pull-request/selectors';

import { PRDescriptionPanelId } from '../utils';

import { EditableDescription } from './editable-description';
import messages from './pull-request-details.i18n';

type DescriptionSectionProps = {
  isContainingPanelExpanded: boolean;
};

export const DescriptionSection = React.memo(
  ({ isContainingPanelExpanded }: DescriptionSectionProps) => {
    const intl = useIntl();
    const prDescription = useSelector(getPullRequestDescription);
    const isOpenPr = useSelector(getIsCurrentPullRequestOpen);
    const containerId = useSelector(getContainerId);

    return (
      <section
        aria-label={intl.formatMessage(messages.descriptionLabel)}
        data-qa="pull-request-description"
        id={PRDescriptionPanelId}
      >
        {isOpenPr ? (
          <EditableDescription
            descriptionHtml={prDescription}
            isContainingPanelExpanded={!isContainingPanelExpanded}
            panelId={PRDescriptionPanelId}
            containerId={containerId}
          />
        ) : (
          <FabricRenderer src={prDescription} format="html" />
        )}
      </section>
    );
  }
);
